import { render } from "./MyReportsDataTable.vue?vue&type=template&id=662e739d&scoped=true"
import script from "./MyReportsDataTable.vue?vue&type=script&lang=js"
export * from "./MyReportsDataTable.vue?vue&type=script&lang=js"

import "./MyReportsDataTable.vue?vue&type=style&index=0&id=662e739d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-662e739d"]])

export default __exports__